import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userInitials, setUserInitials] = useState('');
  const [userName, setUserName] = useState('');

  // Load auth state from localStorage on mount
  useEffect(() => {
    const savedAuthState = localStorage.getItem('authState');
    if (savedAuthState) {
      const { isLoggedIn, userInitials, userName } = JSON.parse(savedAuthState);
      setIsLoggedIn(isLoggedIn);
      setUserInitials(userInitials);
      setUserName(userName);
    }
  }, []);

  const login = (name, email) => {
    let initials = '';
    if (name && name.trim()) {
      const parts = name.trim().split(/\s+/);
      initials = parts.length >= 2
        ? (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
        : parts[0].charAt(0).toUpperCase();
    } else {
      initials = email.charAt(0).toUpperCase();
    }
    
    setIsLoggedIn(true);
    setUserInitials(initials);
    setUserName(name);

    // Save to localStorage
    localStorage.setItem(
      'authState',
      JSON.stringify({
        isLoggedIn: true,
        userInitials: initials,
        userName: name,
      })
    );
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUserInitials('');
    setUserName('');
    localStorage.removeItem('authState');
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userInitials, userName, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
